import { CircularProgress, CircularProgressProps } from "@mui/material"
import styled from "styled-components"

const Backdrop = styled.div`
        width: 100%;
        height: 100%;
        position: fixed;
        top:0;
        left:0;
        background: rgba(255, 255, 255, 0.05);
        backdrop-filter: blur(2px);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        color:white;
`

const Loader = (props: CircularProgressProps) => {
    return <Backdrop>
        <CircularProgress size={100} thickness={3} {...props} color="primary" />
    </Backdrop>
}

export default Loader